import { useResizeDetector } from 'react-resize-detector'
import type { RefObject } from 'react'

/**
 * Thin wrapper around useResizeDetector for use in class components.
 * Observes the element referenced by `targetRef` and calls `onResize`
 * when its dimensions change — without using the deprecated findDOMNode.
 */
export default function ResizeHandler({
  targetRef,
  onResize,
}: {
  targetRef: RefObject<HTMLElement | null>
  onResize: (width?: number, height?: number) => void
}) {
  useResizeDetector({ targetRef, onResize })
  return null
}
